import { render, staticRenderFns } from "./bulk-upload-premium.vue?vue&type=template&id=9baf0150&"
import script from "./bulk-upload-premium.vue?vue&type=script&lang=js&"
export * from "./bulk-upload-premium.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports